// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"203":"1e4b96b2acb5d8c7","894":"ea0f3ead176759af"}[chunkId] + ".js";
};